export enum AppPaths {
	PRODUCT_TYPE_CATEGORIES = 'product-type-categories',
	PRODUCT_TYPES = 'product-types',
	CONFIGURATION = 'configuration',
	CART = 'cart',
}
